import gql from 'graphql-tag'

export const fetchStatesSelect = () => {
	return {
		query: gql`
			{
				states: states(
					where: { active: { _eq: true } }
					order_by: { name: asc }
				) {
					id
					name
				}
			}
		`
	}
}
